import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { Button } from '../../design-system/components/Button';
import { Text } from '../../design-system/components/Typography';
import { Stack } from '../../design-system/components/Layout';
import { spacing } from '../../design-system/tokens/spacing';

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 320px;
  padding: ${spacing[8]};
  text-align: center;
  gap: ${spacing[4]};
`;

interface DashboardErrorStateProps {
  onRetry: () => void;
  message?: string;
}

export const DashboardErrorState: React.FC<DashboardErrorStateProps> = ({
  onRetry,
  message,
}) => {
  const { t } = useTranslation();

  return (
    <Wrap role="alert">
      <ExclamationTriangleIcon width={40} height={40} aria-hidden />
      <Stack direction="column" spacing="sm" align="center">
        <Text size="lg">{message ?? t('dashboard.errors.loadFailed')}</Text>
        <Button variant="primary" size="md" onClick={onRetry}>
          {t('dashboard.errors.retry')}
        </Button>
      </Stack>
    </Wrap>
  );
};

export default DashboardErrorState;
